module.exports = __webpack_public_path__ + "static/media/App.3dd5452d.scss";


//////////////////
// WEBPACK FOOTER
// ./src/App.scss
// module id = 66
// module chunks = 0